import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

/**
 * Tenancy Slide-over Stimulus Controller
 *
 * Manages ActionCable subscriptions for real-time updates to the tenancy slide-over.
 * Follows the pattern from data_subscription_controller.js
 */
export default class extends Controller {
  static values = {
    tenancyId: Number
  }

  connect() {
    this.subscription = null
    this.subscribeToChannel()
  }

  disconnect() {
    this.unsubscribeFromChannel()
  }

  tenancyIdValueChanged() {
    // Re-subscribe when tenancy changes
    this.unsubscribeFromChannel()
    if (this.tenancyIdValue) {
      this.subscribeToChannel()
    }
  }

  subscribeToChannel() {
    if (this.subscription) return

    const controller = this

    this.subscription = consumer.subscriptions.create(
      { channel: "DataUpdatesChannel" },
      {
        connected() {
          console.debug("[TenancySlideover] Connected to DataUpdatesChannel")
        },

        disconnected() {
          console.debug("[TenancySlideover] Disconnected from DataUpdatesChannel")
        },

        received(message) {
          controller.handleMessage(message)
        }
      }
    )
  }

  unsubscribeFromChannel() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  handleMessage(message) {
    // Filter messages for this tenancy
    const relevantTypes = ['tenancy', 'tenancy_agreement', 'rent_increase', 'person']

    if (!relevantTypes.includes(message.type)) return

    console.debug("[TenancySlideover] Received message:", message.type, message.id, "tenancyIdValue:", this.tenancyIdValue)

    // Check if this message is for our tenancy
    const isForThisTenancy =
      (message.type === 'tenancy' && message.id === this.tenancyIdValue) ||
      (message.data?.tenancy_id === this.tenancyIdValue)

    if (!isForThisTenancy) {
      console.debug("[TenancySlideover] Message not for this tenancy, ignoring")
      return
    }

    console.debug("[TenancySlideover] Dispatching message to Alpine")

    // Dispatch custom event for Alpine to handle
    this.dispatch('message', {
      detail: message,
      bubbles: true
    })
  }
}
